import { ReferenceType } from './reference-type';

export class ReferenceBasicData {
    public id: number = 0;
    public type: ReferenceType = ReferenceType.Product;
    public projectId: number = 0;
    public businessId: number = 0;
    public categoryId?: number;
    public topLevelCategoryId?: number;
    public title?: string;
    public description?: string;
    public principalSkuCode?: string;
    public principalSkuPrice?: number;
    public principalSkuPriceDetails?: string;
    public depositSkuPrice?: number;
    public totalValueSkuPrice?: number;
    public particularConditions?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);

        if (this.description) {
            const Entities = require('html-entities').AllHtmlEntities;
            this.description = new Entities().decode(this.description);
        }

        if (this.particularConditions) {
            const Entities = require('html-entities').AllHtmlEntities;
            this.particularConditions = new Entities().decode(this.particularConditions);
        }
    }
}
